// BBB-456: pure helpers for the "Return to zone" action in MapLayerPanel.
// They pull the lat/lng points that make up a zone (or every drawn zone) out of
// the GeoJSON-shaped zone objects, so the panel can build a
// google.maps.LatLngBounds from them. Kept free of any google.maps dependency so
// they're directly unit-testable (unlike fitBounds, which needs a live map).

// Points for a single zone: the polygon ring if the zone is drawn, otherwise its
// centre point. GeoJSON stores coordinates as [lng, lat]; Google Maps wants
// { lat, lng }, so we flip here.
export function zonePoints(zone) {
  if (!zone) return [];

  const ring = zone.polygon_shape?.coordinates?.[0];
  if (Array.isArray(ring) && ring.length > 0) {
    return ring
      .filter((coord) => Array.isArray(coord) && coord.length === 2)
      .map(([lng, lat]) => ({ lat, lng }));
  }

  const centre = zone.center_point?.coordinates;
  if (Array.isArray(centre) && centre.length === 2) {
    return [{ lat: centre[1], lng: centre[0] }];
  }

  return [];
}

// Points across every zone — used as the fallback when no single zone is
// selected, so "Return to zone" fits the whole set instead.
export function allZonesPoints(zones) {
  if (!Array.isArray(zones)) return [];
  return zones.flatMap(zonePoints);
}

// Field-level zoom used when recentring on a single point. Matches ZonesScreen's
// centre-point handling.
export const FIELD_ZOOM = 18;

// Decide how to frame the map for a set of points, WITHOUT touching google.maps
// (so it's unit-testable):
//   - no points            → null (nothing to do)
//   - a single point       → recentre at a fixed field zoom. A centre-point-only
//     zone yields one point, and fitBounds on a zero-size bounds slams to max
//     zoom, so we setCenter + setZoom instead.
//   - two or more points   → fit their bounds.
// The caller applies the result to the live map.
export function framePoints(points) {
  if (!Array.isArray(points) || points.length === 0) return null;
  if (points.length === 1) {
    return { mode: 'center', center: points[0], zoom: FIELD_ZOOM };
  }
  return { mode: 'bounds', points };
}
